import { ColumnStore, DateHelper } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { isPointEligibleForStatusChange } from "../../other/utils/incentiveUtils.jsx";
import {
  EntityMainNameDefault,
  getCustomGroupRenderer
} from "../../other/utils/utils.jsx";
import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { INCENTIVE_POINT_STATUS, INCENTIVE_POINT_STATUS_VALUES } from "@/other/constants/IncentiveKeys.jsx";
import { EDITOR_KEYS } from "../../other/constants/EditorKeys.jsx";

export default class IncentivePointsStatusColumn extends SwivuSortColumn {
  static get fields() {
    return [
      { name: "swivuListTitle", type: "string", readOnly: true, defaultValue: "Status" },
    ];
  }

  static get $name() {
    return "IncentivePointsStatusColumn";
  }

  static get type() {
    return WIDGET_KEYS.incentivePointsStatusColumn;
  }

  get canEmptySwivuList() {
    return false;
  }

  static get defaults() {
    return {
      text: "Status",
      field: "incentiveStatus",
      width: "14em",
      flex: 1,
      filterType: "_swivu_settings",
      htmlEncode: false,
      groupRenderer(e) {
        return getCustomGroupRenderer(e);
      },
      editor: false
    };
  }

  renderer({ record }) {
    if (!record.isGroupHeader && this.project) {
      const statusText = record.incentiveStatus;
      const { statusChangedByUser, statusChangedAt } = record;

      if (statusChangedByUser && statusChangedAt) {
        const formattedDate = DateHelper.format(statusChangedAt, "MMM D, YYYY");
        return EntityMainNameDefault({ text: statusText, class: "entity-main-name-text", html: `<span>${statusText}</span><span class="text-xs text-gray-400">&nbsp;by ${statusChangedByUser.name} on ${formattedDate}</span>` });
      }

      return EntityMainNameDefault({ text: statusText });
    }
  }

  onLoad(project, otherParams) {
    this.project = project;
    this.editorHandler = otherParams?.editorHandler;
  }

  get swivuListItems() {
    const statuses = Object.entries(INCENTIVE_POINT_STATUS_VALUES).reduce((acc, [key, value]) => {
      acc[key] = {
        id: Number(key),
        label: value,
        disabled: false
      }
      return acc;
    }, {});
    const { status } = this.swivuRecord;
    const eligibiltyByStatus = isPointEligibleForStatusChange(status, this.project);
    return Object.values(statuses).map((status) => ({
      ...status,
      disabled: !eligibiltyByStatus[status.id]
    }));
  }

  getSwivuListItemDisplayValue(record) {
    return record.label;
  }

  getSelectedSwivuListItem(record) {
    return record.status;
  }

  onSwivuListSelectionChange(record, [statusRecord], editor) {
    const newStatus = statusRecord.id;

    // If changing to AWARDED status, open the Award Tag modal
    if (newStatus === INCENTIVE_POINT_STATUS.AWARDED && this.editorHandler) {
      this.editorHandler.openEditor(EDITOR_KEYS.awardTagEditor, null, {
        pointRecords: [record]
      }, { by: "recordType", useExisting: false });
    }
    // For other status changes, just update the status
    record.status = newStatus;
    editor.swivuRefreshListItems(this.swivuListItems);
  }
}

ColumnStore.registerColumnType(IncentivePointsStatusColumn);
